/**
 * Resolves a logical asset path to its fingerprinted URL using the Rails asset manifest.
 * Falls back to /assets/{path} if manifest is not available or path not found.
 *
 * @param {string} path - Logical asset path (e.g., "hero-image.png")
 * @returns {string} - Fingerprinted asset URL (e.g., "/assets/hero-image-abc123.png")
 */
export function assetPath(path) {
  if (typeof window !== 'undefined' && window.assetManifest && window.assetManifest[path]) {
    return window.assetManifest[path];
  }
  // Fallback for SSR or missing manifest
  return `/assets/${path}`;
}

export default assetPath;
